import script from "./SubscribePlanItemCompareRow.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlanItemCompareRow.vue?vue&type=script&setup=true&lang=js"

import "./SubscribePlanItemCompareRow.vue?vue&type=style&index=0&id=37dbdde0&lang=css"

const __exports__ = script;

export default __exports__